import type { DealerChangeLogItemDto } from "src/app/features/DealerChangeLog/types/DealerChangeLogItemDto";
import type { DealerChangeLogItemEntity } from "src/app/features/DealerChangeLog/types/DealerChangeLogItemEntity";
import type { DealerChangeLogDto } from "../../types/DealerChangeLogDto";
import type { DealerChangeLogEntity } from "../../types/DealerChangeLogEntity";

const mapDealerChangeLogItemDtoToEntity = (dto: DealerChangeLogItemDto): DealerChangeLogItemEntity => {
    return {
        ...dto,
    };
};

export const DealerChangeLogDtoToEntity = (dto: DealerChangeLogDto): DealerChangeLogEntity => {
    return {
        logItems: dto.logItems?.map(mapDealerChangeLogItemDtoToEntity) ?? [],
    };
};
